import { SelectToken } from "~/lib/models/tokens";
import { Token } from "~/lib/types";
import { classNames, getIconUrl, onIconError } from "~/lib/util";

type Props = {
   token: SelectToken;
   darkMode?: boolean
};

export default function TokenRow({ token, darkMode }: Props) {
	return (
      <div className="grow flex-none">
         <div className={classNames(
            darkMode ? 'text-white' : 'text-black',
            'relative w-full  hover:text-primary-500 rounded-md pr-10 py-2 text-left focus:outline-3 focus:ring-1 focus:ring-primary-200 focus:border-primary-300 sm:text-sm')}>
            <span className="flex items-center">
               <img src={getIconUrl(token.iconUrl)} onError={(evt) => onIconError(evt)} alt="" className="shrink-0 h-8 w-8 rounded-full" />
               <span className="ml-3 block text-xl font-medium">{token.symbol}</span>
               {/* <span className="ml-3 text-xs text-gray-500 truncate">{token.name}</span> */}
            </span>
         </div>
      </div>
   );
}